<p-messages [enableService]="true" [closable]="false"></p-messages>

<form [formGroup]="formGroup" (ngSubmit)="pesquisar()">
	<div class="my-3 p-4 shadow-sm bg-gray-2">
		<div class="row">
			<div class="col-sm-12 col-md-8 br-input">
				<label for="campo-nome">Nome do Concurso:</label>
				<input
					#elTextoPesquisa
					name="textoPesquisa"
					pInputText
					type="text"
					data-cy="campo-texto"
					[(ngModel)]="textoPesquisa"
					[ngModelOptions]="{standalone: true}"
					maxlength="100"
					placeholder="Busque aqui pelo nome do concurso"
				/>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-6 mt-2 br-input">
				<label for="campo-situacao">Situação:</label>
				<p-dropdown
					[options]="(tabelaService.situacoes$ | async)!"
					name="situacao"
					formControlName="situacao"
					placeholder="Selecione"
					[showClear]="true"
					[(ngModel)]="situacao"
					optionLabel="descricao"
					optionValue="codigo"
					id="campo-situacao"
					data-cy="campo-situacao"
				></p-dropdown>
			</div>
			<div class="col-sm-12 col-md-2 br-input">
				<label for="campo-codigo">Código do Concurso:</label>
				<input
					#elTextoPesquisa
					name="codigoPesquisa"
					pInputText
					type="text"
					data-cy="campo-texto"
					[(ngModel)]="codigoPesquisa"
					[ngModelOptions]="{standalone: true}"
					maxlength="10"
					placeholder="Informe o código"
				/>
			</div>
		</div>
		<div class="row mt-2">
			<div class="col-sm-12 col-md-8 br-checkbox d-inline mt-2">
				<input
					id="utiliza_perfil"
					[(ngModel)]="utiliza_perfil"
					[ngModelOptions]="{standalone: true}"
					type="checkbox"
					aria-label="Somente com perfil profissiográfico habilitado"
					data-cy="campo-somente-habilitado"
				/>
				<label for="utiliza_perfil">Somente habilitados para perfil profissiográfico</label>
			</div>
			<div class="col-sm-12 col-md-4 text-right">
				<button id="btnLimpar" data-cy="botao-limpar" class="secondary" (click)="limpar()" type="button" pButton>Limpar</button>
				<button id="btnPesquisar" data-cy="botao-pesquisar" class="primary ml-3" (click)="pesquisar()" type="button" pButton>
					Pesquisar
				</button>
			</div>
		</div>
	</div>
</form>
